import { FormField } from '@/components/forms';
import { Input } from '@/components/ui/input';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Info } from 'lucide-react';
import type { TriggerAction } from '../../types';

interface FamilySlotsFormProps {
  action: TriggerAction;
  onChange: (patch: Partial<TriggerAction>) => void;
}

/**
 * FamilySlotsForm
 *
 * Форма действия изменения слотов семейной подписки
 *
 * @returns {React.ReactElement} React компонент
 */
export function FamilySlotsForm({ action, onChange }: FamilySlotsFormProps) {
  return (
    <div className="space-y-4">
      <Alert>
        <Info className="h-4 w-4" />
        <AlertDescription>
          ID подписки берётся из данных события (subscriptionId). Укажите на сколько изменить количество слотов.
        </AlertDescription>
      </Alert>

      <FormField
        label="Изменение слотов"
        name="delta"
        hint="Положительное число - добавить, отрицательное - убрать"
      >
        <Input
          type="number"
          value={action.delta ?? 0}
          onChange={(e) => onChange({ delta: Number(e.target.value) })}
          placeholder="0"
        />
      </FormField>

      <div className="text-xs text-muted-foreground">
        <p>Примеры:</p>
        <ul className="list-disc list-inside mt-1 space-y-0.5">
          <li><code>+1</code> — добавить 1 слот</li>
          <li><code>-1</code> — убрать 1 слот</li>
          <li><code>+5</code> — добавить 5 слотов</li>
        </ul>
      </div>
    </div>
  );
}
